export default "__VITE_ASSET__AgcT_DUo__"